import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const AboutPage = () => (
  <Box sx={{ p: 3 }}>
    <Paper sx={{ p: 3 }}>
      <Typography variant="h4">About</Typography>
      <Typography>LGD & CCF Platform – Credit Risk Modelling Suite</Typography>
    </Paper>
  </Box>
);

export default AboutPage;
